import { fromJson } from '@bufbuild/protobuf';
import type { ThinkingModeEntity } from '@platform/timeline';
import {
  ThinkingModeCompletedSchema,
  ThinkingModeStartedSchema,
  ThinkingModeUpdateSchema,
} from '../pb/proto/sem/middleware/thinking_mode_pb';
import { registerSem } from '../registry';

registerSem('thinking.mode.started', ({ ev, now, convId }) => {
  const pb = fromJson(ThinkingModeStartedSchema, (ev.data || {}) as any);
  const entityId = pb.itemId;
  if (!entityId) return null;
  return {
    kind: 'add',
    convId,
    entity: {
      id: entityId,
      kind: 'thinking_mode',
      timestamp: now,
      props: {
        status: 'active',
        mode: pb.data?.mode ?? undefined,
        phase: pb.data?.phase ?? undefined,
        reasoning: pb.data?.reasoning ?? undefined,
        extraData: (pb.data as any)?.extraData ?? undefined,
      },
    } as ThinkingModeEntity,
  };
});

registerSem('thinking.mode.update', ({ ev, now, convId }) => {
  const pb = fromJson(ThinkingModeUpdateSchema, (ev.data || {}) as any);
  const entityId = pb.itemId;
  if (!entityId) return null;
  return {
    kind: 'upsert',
    convId,
    entity: {
      id: entityId,
      kind: 'thinking_mode',
      timestamp: now,
      props: {
        status: 'active',
        mode: pb.data?.mode ?? undefined,
        phase: pb.data?.phase ?? undefined,
        reasoning: pb.data?.reasoning ?? undefined,
        extraData: (pb.data as any)?.extraData ?? undefined,
      },
    } as ThinkingModeEntity,
  };
});

registerSem('thinking.mode.completed', ({ ev, now, convId }) => {
  const pb = fromJson(ThinkingModeCompletedSchema, (ev.data || {}) as any);
  const entityId = pb.itemId;
  if (!entityId) return null;
  return {
    kind: 'upsert',
    convId,
    entity: {
      id: entityId,
      kind: 'thinking_mode',
      timestamp: now,
      props: {
        status: pb.success === false ? 'error' : 'completed',
        mode: pb.data?.mode ?? undefined,
        phase: pb.data?.phase ?? undefined,
        reasoning: pb.data?.reasoning ?? undefined,
        extraData: (pb.data as any)?.extraData ?? undefined,
        success: pb.success ?? undefined,
        error: pb.error ?? undefined,
      },
    } as ThinkingModeEntity,
  };
});
